import React, { useEffect, useState } from "react";
import Block from "../../adapters/helpers/Block";
import Image from "../Image/Image";
import { mediaQueryHOC } from "../../adapters/helpers/Hooks";
import { AnalyticsConstants } from "../../adapters/helpers/ConstantsGA";
import { StartGuideBlockConstants } from "../../adapters/helpers/Constants";
import { redirectTo } from '../../adapters/helpers/Utils';

const PageProgressBar = (props) => {
  const block = new Block(props);
  const { isXSmall, isSmall } = props;
  const TroubleshootingUrl = props?.document?.fields?.troubleshootingUrl?.fields?.url;

  const hamburgerIcon = block.getFieldValue(
    StartGuideBlockConstants.hamburgerIcon
  );
  const closeIcon = block.getFieldValue(StartGuideBlockConstants.closeIcon);
  const classData = block.getFieldValue(StartGuideBlockConstants.classData);

  const [visible, setVisible] = useState(false);
  const [currentClassName, setCurrentClassName] = useState("");
  const [isAtTop, setIsAtTop] = useState(true);

  const toggleHamburger = () => {
    setVisible(!visible);
  };

  const scrollToElement = (className) => {
    const element = document.getElementById(`${className}`);

    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleSectionClick = (className) => {
    setCurrentClassName(className);
    scrollToElement(className);
  };

  const isElementInViewport = (id) => {
    const element = document.getElementById(id);
    if (!element) {
      return false;
    }

    const rect = element.getBoundingClientRect();
    const isInViewport = rect.top <= 500;
    return isInViewport;
  };

  useEffect(() => {
    const handleScroll = () => {
      Object.values(classData).forEach((id) => {
        if (isElementInViewport(id)) {
          setCurrentClassName(id);
        }
      });
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  
  const redirectToHelp = () => {
    redirectTo(TroubleshootingUrl);
  };

  return (
    <div className={`progress-tracker-container ${visible ? "visible" : ""}`}>
      {isSmall || isXSmall ? (
        <>
          {!visible && (
            <button
              onClick={toggleHamburger}
              className="event_menu_click"
              data-action-detail={AnalyticsConstants.openMenu}
            >
              <Image image={hamburgerIcon} />
            </button>
          )}
          {visible && (
            <>
              <button onClick={toggleHamburger}>
                <Image image={closeIcon} className="event_close_window" />
              </button>
              <ul className="progress-tracker progress-tracker--vertical">
                {classData &&
                  Object.entries(classData).map(([name, className]) => {
                    return (
                      <li class='progress-step' key={name}>
                        <button
                          onClick={() => {const isIssueLink = name === StartGuideBlockConstants.clickHereBtnText;
                            if (isIssueLink) {
                              redirectToHelp();
                              toggleHamburger();
                            } else {
                              scrollToElement(className);
                              toggleHamburger();
                            }}}
                          className="progress-text event_button_click"
                          data-action-detail={name}
                        >
                          {name}
                        </button>
                        <div className="progress-marker"></div>
                      </li>
                    );
                  })}
              </ul>
            </>
          )}
        </>
      ) : (
        <ul className="progress-tracker progress-tracker--vertical">
          {classData &&
            Object.entries(classData).map(([name, className]) => {
              const isIssueLink = name === StartGuideBlockConstants.clickHereBtnText;
              return (
                <li
                  class={`progress-step ${className == currentClassName ? 'is-active' : ''
                    } ${isAtTop ? 'scrolled-top' : ''}`}
                  key={name}
                >
                  <button
                    onClick={() => {
                      if (isIssueLink) {
                        redirectToHelp();
                      } else {
                        handleSectionClick(className);
                      }
                    }}
                    className="progress-text event_button_click"
                    data-action-detail={name}
                  >
                    {name}
                  </button>
                  <div className="progress-marker"></div>
                </li>
              );
            })}
        </ul>
      )}
    </div>
  );
};

export default mediaQueryHOC(PageProgressBar);
